import { PercentageBarRowPlaceholder } from './percentage-bar-row/percentage-bar-row.placeholder';

export function PercentageBarChartPlaceholder({ rowCount }: { rowCount: number }) {
  return (
    <>
      {Array(rowCount)
        .fill('')
        .map(() => (
          <PercentageBarRowPlaceholder />
        ))}
    </>
  );
}
